import { useSearchParams } from 'react-router-dom';

import { PRODUCTS_TABLE_PAGE_SIZE } from '../shared/constants/products.constant';
import { parseString } from '../shared/helpers/url-parameter-parser';
import { GetProductsProps } from './api/products';

type ProductsTableQueryState = {
  skip: number;
  size: number;
  filters: Partial<GetProductsProps>;
  sort: string | undefined;
  setParams: (params: Record<string, string | number | string[] | undefined>) => void;
};

export const useProductsTableQueryParams = (): ProductsTableQueryState => {
  const [sp, setSp] = useSearchParams();

  // Pagination
  const skip =
    (Number(sp.get('page') ?? 1) - 1) * Number(sp.get('size') ?? PRODUCTS_TABLE_PAGE_SIZE);
  const size = Number(sp.get('size') ?? PRODUCTS_TABLE_PAGE_SIZE);

  // Sorting
  const sort = sp.get('sort') ?? '';

  // Filters
  const filters: Partial<GetProductsProps> = {
    country: parseString(sp.get('country')),
    region: parseString(sp.get('region')),
    tagId: parseString(sp.get('tagId')),
    search: parseString(sp.get('search')),
    permittedCompanyId: parseString(sp.get('permittedCompanyId')),
    permittedBpn: parseString(sp.get('permittedBpn')),
  };

  // Function to set multiple URL params at once
  const setParams = (params: Record<string, string | number | string[] | undefined>): void => {
    const next = new URLSearchParams(sp);

    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || (Array.isArray(value) && value.length === 0) || value === '') {
        next.delete(key);

        return;
      }

      if (Array.isArray(value)) {
        next.set(key, value.join(','));

        return;
      }

      next.set(key, String(value));
    });

    setSp(next, { replace: true });
  };

  return {
    skip,
    size,
    sort,
    filters,
    setParams,
  };
};
